module.exports = __webpack_public_path__ + "media/1x1/mv-0fdc08c6.svg";